import { render } from "./LayoutDefault.vue?vue&type=template&id=3f0e6656"
const script = {}

import exportComponent from "/Users/mhall/dev/rorserver/newcomb/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__